export default __webpack_public_path__ + "static/cloud-migration-emea-white-c24b70db9e2061c6cd4a20f6a4a50dfd.svg";